import { IEquipment } from '@/pages/Equipment/equipment.types.ts'
import { IComputedParameterDef, TParameterKey } from '@/pages/Parameters/parameters.types.ts'
import { useId, useMemo } from 'react'
import useLastValuesWithComputedRef, { IUseLastValuesWithComputedProps } from './useLastValuesWithComputedRef'
import useForceRerender from '@/shared/hooks/useForceRerender'

interface IProps {
  equipmentId: IEquipment['id']
  parameters: TParameterKey[]
  computed?: IComputedParameterDef[]
  live?: boolean
  ts?: number
}

const useParametersValues = (props: IProps) => {
  const dataSubscriptionId = useId()
  const forceRerender = useForceRerender()

  const config: IUseLastValuesWithComputedProps = useMemo(() => {
    return {
      live: props.live !== false,
      parameters: props.parameters,
      computed: props.computed ?? [],
      devices: [props.equipmentId],
      id: dataSubscriptionId,
      tsFrom: props.live !== false ? Date.now() - 5000 : props.ts,
      onNewValueReceived: forceRerender,
    }
  }, [props.computed, props.live, props.ts, props.equipmentId, props.parameters, dataSubscriptionId])

  const lastValues = useLastValuesWithComputedRef(config)

  return {
    values: { ...(lastValues.ref.current[props.equipmentId] ?? {}) },
    loading: lastValues.loading,
  }
}

export default useParametersValues
